import { render, staticRenderFns } from "./BrandMiddleBox.vue?vue&type=template&id=2164a376"
import script from "./BrandMiddleBox.vue?vue&type=script&lang=js"
export * from "./BrandMiddleBox.vue?vue&type=script&lang=js"
import style0 from "./BrandMiddleBox.vue?vue&type=style&index=0&id=2164a376&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports